import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import useOrientationWarning from "../hook/useOrientationWarning";
import OrientationSizePopup from "./OrientationSizePopup";
import { doRequest } from "../utils/helper";
import { config } from "../utils/config";
import { useDispatch } from "react-redux";
import { setAllData } from "../redux/slices/PlanDetailSlice";
import { setUserData } from "../redux/slices/UserSlice";
import { ToastContainer } from "react-toastify";
import {
  setAnalyticsTags,
  trackRouteEntered,
  trackRouteExited,
  trackSessionEnded,
  trackSessionStarted,
} from "../utils/analytics";

const Layout = ({ children }) => {
  const isPortrait = useOrientationWarning();
  const location = useLocation();
  const dispatch = useDispatch();
  const sessionStartTimeRef = useRef(Date.now());
  const routeStartTimeRef = useRef(Date.now());
  const currentPathRef = useRef(location?.pathname || "/");
  const isSessionEndedRef = useRef(false);
  const isRouteTrackingInitializedRef = useRef(false);

  const showOrientationComponentRoutes = [
    "/tshirtFront",
    "/design",
    "/variation",
    "export-new",
    "export",
    "editDesign",
    "home",
  ];
  const shouldShowOrientationComponent =
    showOrientationComponentRoutes.includes(location?.pathname?.toLowerCase());



  const getUserData = async (email) => {
    try {
      const data = {
        email,
      };
      const response = await doRequest(data, 'POST', 'user/data');
      if (response?.resultFlag == 1) {
        dispatch(setUserData({ userData: response?.response?.user }));
        // dispatch(setPlanDetails({userPlanDetails:response?.response?.userPlan}))
        // dispatch(setVariationCountDetails(response?.response?.variants))
        dispatch(
          setAllData({
            userPlanDetails: response?.response?.userPlan,
            variants: response?.response?.variants,
          })
        );
      }
    } catch (error) {
      // console.log('user data api error is', error);
    }
  };



  useEffect(() => {
    // getUserData();
  }, []);

  useEffect(() => {
    const currentPath = location?.pathname || "/";

    if (!isRouteTrackingInitializedRef.current) {
      isRouteTrackingInitializedRef.current = true;
      currentPathRef.current = currentPath;
      routeStartTimeRef.current = Date.now();
      sessionStartTimeRef.current = Date.now();

      try {
        const storedUser = localStorage.getItem(config.USER_LOGIN_DETAILS);
        if (storedUser) {
          const parsedUser = JSON.parse(storedUser);
          setAnalyticsTags({
            user_id: parsedUser?.id,
            user_type: parsedUser?.type,
            user_email: parsedUser?.email,
          });
        }
      } catch (error) {
        // Ignore invalid localStorage data.
      }

      trackSessionStarted({ entryPath: currentPath });
      trackRouteEntered({
        pathname: currentPath,
        previousPath: "",
        isEntry: true,
      });
      return;
    }

    const previousPath = currentPathRef.current;
    if (previousPath === currentPath) {
      return;
    }

    const now = Date.now();
    trackRouteExited({
      pathname: previousPath,
      nextPath: currentPath,
      durationMs: now - routeStartTimeRef.current,
      reason: "navigate",
    });
    trackRouteEntered({
      pathname: currentPath,
      previousPath,
      isEntry: false,
    });

    currentPathRef.current = currentPath;
    routeStartTimeRef.current = now;
  }, [location?.pathname]);

  useEffect(() => {
    const flushSession = () => {
      if (
        isSessionEndedRef.current ||
        !isRouteTrackingInitializedRef.current
      ) {
        return;
      }

      isSessionEndedRef.current = true;
      const now = Date.now();
      const currentPath = currentPathRef.current;

      trackRouteExited({
        pathname: currentPath,
        durationMs: now - routeStartTimeRef.current,
        reason: "session_end",
      });
      trackSessionEnded({
        exitPath: currentPath,
        totalDurationMs: now - sessionStartTimeRef.current,
      });
    };
    window.addEventListener("pagehide", flushSession);
    window.addEventListener("beforeunload", flushSession);

    return () => {
      window.removeEventListener("pagehide", flushSession);
      window.removeEventListener("beforeunload", flushSession);
    };
  }, []);

  if (shouldShowOrientationComponent && isPortrait) {
    return (
      <>
        <OrientationSizePopup />
        <ToastContainer />
      </>
    );
  }

  return <div>
    {children}
    <ToastContainer/>
  </div>;
};

export default Layout;
